import React from 'react';

const CoverLetterForm = ({ coverLetterData, setCoverLetterData, formData = {}, language, t }) => {
  
  const handleInputChange = (field, value) => {
    setCoverLetterData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="cover-letter-form">
      {/* SECTION INFORMATIONS PERSONNELLES */}
      <div className="form-section">
        <h3>{language === 'fr' ? 'VOS COORDONNÉES' : 'YOUR INFORMATION'}</h3>
        
        <div className="form-group">
          <label>{language === 'fr' ? 'Nom complet *' : 'Full Name *'}</label>
          <input
            type="text"
            value={coverLetterData.candidateName || formData.name || ''}
            onChange={(e) => handleInputChange('candidateName', e.target.value)}
            placeholder={language === 'fr' ? "Prénom et Nom" : "First and Last Name"}
          />
        </div>

        <div className="form-group">
          <label>{language === 'fr' ? 'Adresse *' : 'Address *'}</label>
          <input
            type="text"
            value={coverLetterData.candidateAddress || formData.address || ''}
            onChange={(e) => handleInputChange('candidateAddress', e.target.value)}
            placeholder={language === 'fr' ? "Adresse complète" : "Complete address"}
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>{language === 'fr' ? 'Téléphone *' : 'Phone *'}</label>
            <input
              type="text"
              value={coverLetterData.candidatePhone || formData.phone || ''}
              onChange={(e) => handleInputChange('candidatePhone', e.target.value)}
              placeholder={language === 'fr' ? "Numéro de téléphone" : "Phone number"}
            />
          </div>
          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              value={coverLetterData.candidateEmail || formData.email || ''}
              onChange={(e) => handleInputChange('candidateEmail', e.target.value)}
              placeholder="email@example.com"
            />
          </div>
        </div>
      </div>

      {/* SECTION ENTREPRISE */}
      <div className="form-section">
        <h3>{language === 'fr' ? 'INFORMATIONS ENTREPRISE' : 'COMPANY INFORMATION'}</h3>
        
        <div className="form-group">
          <label>{t.companyName}</label>
          <input
            type="text"
            value={coverLetterData.companyName || ''}
            onChange={(e) => handleInputChange('companyName', e.target.value)}
            placeholder={language === 'fr' ? "Nom de l'entreprise" : "Company name"}
          />
        </div>

        <div className="form-group">
          <label>{t.positionTitle}</label>
          <input
            type="text"
            value={coverLetterData.positionTitle || ''}
            onChange={(e) => handleInputChange('positionTitle', e.target.value)}
            placeholder={language === 'fr' ? "Poste visé" : "Target position"}
          />
        </div>

        <div className="form-group">
          <label>{t.hiringManager}</label>
          <input
            type="text"
            value={coverLetterData.hiringManager || ''}
            onChange={(e) => handleInputChange('hiringManager', e.target.value)}
            placeholder={language === 'fr' ? "Nom du recruteur" : "Recruiter name"}
          />
        </div>
      </div>

      {/* SECTION CORPS DE LA LETTRE */}
      <div className="form-section">
        <h3>{language === 'fr' ? 'CONTENU DE LA LETTRE' : 'LETTER CONTENT'}</h3>
        
        <div className="form-group">
          <label>{t.letterBody}</label>
          <textarea
            value={coverLetterData.letterBody || ''}
            onChange={(e) => handleInputChange('letterBody', e.target.value)}
            placeholder={language === 'fr' 
              ? "Rédigez le contenu de votre lettre de motivation..." 
              : "Write your cover letter content..."}
            rows="10"
          />
        </div>
      </div>
    </div>
  );
};

export default CoverLetterForm;